import { useReactTable } from "react-table-8.10.7";
import {
  Transactions as TransactionsType,
  TxnAccountType,
} from "types/Models/books";
import { TXN_GROUP_BY, TxnGroupBy } from "constants/bookkeeping";
import { groupTransactionsByVendor } from "./utils/groupByVendor";
import { TransactionVendorGroupAccordion } from "./TransactionVendorGroupAccordion";
import type { TransactionTableColumns } from "./TransactionsTable";

type Props = {
  groupBy: TxnGroupBy | null;
  transactions: TransactionsType[];
  table: ReturnType<typeof useReactTable<TransactionsType>>;
  onRowClick: (
    uuid: string,
    e: Event | React.MouseEvent<HTMLTableRowElement, MouseEvent>
  ) => void;
  isRowsSelected: boolean;
  actionIconColumn: string[];
  firstPinnedColumn: string | undefined;
  animateTransactions: string[];
  onAnimateComplete: () => void;
  updateFilter: <S extends keyof TransactionTableColumns>(
    name: S,
    newValue: TransactionTableColumns[S]
  ) => void;
  values: TransactionTableColumns;
  txnAccountType?: TxnAccountType;
};

export const TxnGroupByView = ({
  groupBy,
  transactions,
  table,
  onRowClick,
  isRowsSelected,
  actionIconColumn,
  firstPinnedColumn,
  animateTransactions,
  onAnimateComplete,
  updateFilter,
  values,
  txnAccountType,
}: Props) => {
  if (groupBy === TXN_GROUP_BY.VENDOR) {
    const vendorGroups = groupTransactionsByVendor(transactions);

    return (
      <div className="t-overflow-auto scrollbar-visible t-max-h-[calc(100vh-230px)] t-w-full t-pb-32">
        <TransactionVendorGroupAccordion
          vendorGroups={vendorGroups}
          table={table}
          onRowClick={onRowClick}
          isRowsSelected={isRowsSelected}
          actionIconColumn={actionIconColumn}
          firstPinnedColumn={firstPinnedColumn}
          animateTransactions={animateTransactions}
          onAnimateComplete={onAnimateComplete}
          updateFilter={updateFilter}
          values={values}
          txnAccountType={txnAccountType}
        />
      </div>
    );
  }

  return null;
};
